import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconCloudOff = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--cloud-off")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
          <path d="M9.908 3.004a1 1 0 0 0-.176 1.992 7 7 0 0 1 6.169 5.25 1 1 0 0 0 .969.754h1.26a4 4 0 0 1 3.689 5.56 1 1 0 1 0 1.842.78A6 6 0 0 0 18.129 9h-.517a9 9 0 0 0-7.704-5.996zM.423.293a1 1 0 0 1 1.414 0l22 22a1 1 0 0 1-1.414 1.414l-2.88-2.877c-.461.112-.936.17-1.413.17H9.146A9 9 0 0 1 3.552 4.837l-3.13-3.13a1 1 0 0 1 0-1.414zm4.56 5.976A7 7 0 0 0 9.13 19h8.585z" id="icon--centivo--cloud-off"/>
      </defs>
      <g fill="none" fillRule="evenodd">
          <use fill="currentColor" xlinkHref="#icon--centivo--cloud-off"/>
      </g>
  </IconWrapper>
)
